module.exports = __webpack_public_path__ + "static/media/organization-of-a-public-dialogue-workshop-for-the-SIENNA-project-mini.f1b31410.jpg";